import styled, { css } from 'styled-components';
import Colors from 'constants/Colors';

export const ClausesContainer = styled.div`
  margin: 10px;
  border: 1px solid ${Colors.GRAY[3]};
  padding: 10px;
`;

export const ClauseGroupContainer = styled.div`
  ${({ visible }) => !visible && css`display: none;`};
`;

export const ClauseContent = styled.div`
  display: ${({ visible }) => visible ? 'flex' : 'none' };
	margin-bottom: 15px;
  align-items: center;
  color: ${Colors.GRAY[6]};
  font-weight: 700;
  font-size: 13px;
  text-align: left;
  min-height: 30px;
  padding-left: 10px;
`;

export const IconsContainer = styled.div`
  display: flex;
  align-items: center;
  margin-right: 10px;

  .icon-arrowup {
    width: 20px;
    height: 20px;
    min-width: 20px;
    transition: transform ease-in-out 200ms;
    margin-left: 8px;
    cursor: pointer;

    &:before{
      background-size: 100%;
      width: 80%;
      height: 80%;
      margin: 10%;
    }
    
    &.closed {
      transform: rotate(180deg);
    }
  }
`;